(function dynamicTextDirectiveDefinition() {
    'use strict';

    angular.module('CustomControlCombo', [])
        .directive('dynamicCombo', function () {
            return {
                replace: true,
                restrict: 'E',
                templateUrl: '/app/directives/custom-control-combo/custom-control-combo-template.html',
                controller: [
                '$scope', function ($scope) {
                    if ($scope.data && $scope.data.metadataOptions && (typeof $scope.data.metadataOptions === 'string')) {
                        $scope.data.metadataOptions = $.parseJSON($scope.data.metadataOptions);
                    }
                }]
            };
        });

    angular.module('CustomControlCombo')
       .directive('dynamicFilterCombo', ['$translate', function () {
           return {
               templateUrl: '/app/directives/custom-control-combo/custom-control-filter-combo-template.html',
               replace: true,
               restrict: 'E',
               controller: [
                   '$scope', function ($scope) {
                       if ($scope.data && !$scope.data.metadataSearchTypeFrom) {
                           $scope.data.metadataSearchTypeFrom = 'Equal';
                       }

                       if ($scope.data && $scope.data.metadataOptions && (typeof $scope.data.metadataOptions === 'string')) {
                           $scope.data.metadataOptions = $.parseJSON($scope.data.metadataOptions);
                       }
                   }
               ]
           };
       }]);
})();